import React, { useState, useEffect } from "react";
import { FaXbox } from "react-icons/fa";
import { AiOutlineAim } from "react-icons/ai";
import { BsGlobe } from "react-icons/bs";
import { BsFillPersonFill } from "react-icons/bs";
import {getAuthorization} from "../../axios/AxiosAut";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../table/Table"; // new

function CompanyProfile() {
  const [CompanyEmployees, setCompanyEmployees] = useState([]);
  const [CompanyDetails, setCompanyDetails] = useState({});

  useEffect(() => {
    //Get company details
    getAuthorization()
      .get("company/company_details/")
      .then((res) => {
        setCompanyDetails(res.data.data);
      })
      .catch((err) => {
        console.log("Error in getting Company details", err);
      });
  }, []);
  console.log("CompanyDetails", CompanyDetails.company_name);

  useEffect(() => {
    //Get Company Employees
    getAuthorization()
      .get("company/company_employees/")
      .then((res) => {
        setCompanyEmployees(res.data);
      })
      .catch((err) => {
        console.log("Error in getting user groups", err);
      });
  }, []);
  const data = CompanyEmployees;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        Cell: AvatarCell,
        imgAccessor: "profile_picture",
      },
      {
        Header: "Job Role",
        accessor: "job_role",
        // Filter: SelectColumnFilter, // new
        filter: "includes",
      },
      {
        Header: "Date Joined",
        // accessor: "date",
        // Cell: StatusPill,
      },
      {
        Header: "Action",
        // accessor: "action",
      },
    ],
    []
  );
  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="w-full">
          <div>
            <h2 className="font-Montserrat text-xl font-bold text-black">
              Company details
            </h2>
            <div className="border-b-2 border-blue-200 w-12"></div>
          </div>
        </div>
      </div>
      <div className="flex flex-col space-y-5 w-1/2">
        <div className="mt-3 ml-8">
          <div>
            <div className="flex flex-row space-x-3">
              <FaXbox size={30} color="#C000F5" />
              <p className="font-Montserrat text-lg font-medium">
                {CompanyDetails.company_name}
              </p>
            </div>
            <p className="font-Montserrat text-xs text-gray-300 ml-11 mb-2">
              {CompanyDetails.total_staff} employees
            </p>
            <div className="flex flex-row space-x-3 mt-6">
              <AiOutlineAim size={20} color="#1F78B4" />
              <p className="font-Roboto text-sm text-gray-600">
                {CompanyDetails.city}, {CompanyDetails.state},{" "}
                {CompanyDetails.country}, {CompanyDetails.postal_code}
              </p>
            </div>
            <div className="flex flex-row space-x-3 mt-4">
              <BsGlobe size={20} color="#1F78B4" />
              <p className="font-Roboto text-sm text-gray-600">
                www.website.com
              </p>
            </div>
            <div className="flex flex-row space-x-3 mt-4">
              <BsFillPersonFill size={20} color="#1F78B4" />
              <p className="font-Roboto text-sm text-gray-600">
                {CompanyDetails.total_staff} employees
              </p>
            </div>
          </div>
          <div className="mt-9">
            <p className="font-Montserrat font-semibold text-base text-blue-100">
              Users
              <div className="border-b-2 border-blue-200 w-7" />
            </p>
          </div>
        </div>
      </div>
      <div className="min-h-screen">
        <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
          <div className="mt-1">
            <Table columns={columns} data={data} text="Undefined" />
          </div>
        </main>
      </div>
    </>
  );
}

export default CompanyProfile;
